export const types = {
    SEND_REQUEST: 'SEND_REQUEST',
    SEND_REQUEST_SUCCESS: 'SEND_REQUEST_SUCCESS',
    SEND_REQUEST_FAILURE: 'SEND_REQUEST_FAILURE'
}